module.exports = __webpack_public_path__ + "img/galactica_blueprints_09.580fb99b.png";